import(/* webpackMode: "eager", webpackExports: ["Terminal"] */ "/app/app/(dashboard)/terminal.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.0.0-canary.152_react-dom@19.0.0-rc-7771d3a7-20240827_react@19.0.0-rc-7771d3a7-20240827/node_modules/next/dist/client/link.js");
